<div
  class="dot-indicator-container"
  [style.display]="isVisible() ? 'block' : 'none'"
>
  <div [class]="dotContainerClassName" [attr.aria-label]="ariaLabel()">
    <span
      class="blue-dot"
      [class.hoverable]="!!tooltip()"
      [libTooltip]="tooltip()"
      [attr.aria-description]="ariaDescription()"
      [triggers]="tooltip() ? tooltipTriggers() : undefined"
      [attr.tabindex]="tooltip() ? 0 : undefined"
      [containerClass]="tooltip() ? tooltipContainerClass() : undefined"
      >&#x2022;</span
    >
    @if (label()) {
      <span class="label">{{ label() }}</span>
    }
  </div>
</div>
